<template>
  <div>
    <div v-if="!showAddRole && !showAssignPermission && hasPermission('Add Role')" class="btn-group-hdr">
        <div class="btn-group btn-group-toggle">
            <!--<router-link :to="create" class="btn btn-primary btn-sm">Add Role</router-link>-->
            <button class="btn btn-primary btn-sm" @click="showAddRole = true">Add Role</button>
        </div>
    </div>

    <add-edit-role
          v-if="showAddRole"
          :role="editingRole"
          @cancel="cancelEdit"
          @role-added="onRoleAdded"
          @role-updated="onRoleUpdated"
        ></add-edit-role>

    <assign-permission
      v-if="showAssignPermission"
      :role="roleForPermission"
      :permissions="rolePermissions"
      @cancel="cancelAssignPermission"
      @save="saveAssignedPermissions"
    />


    <div v-if="!showAddRole && !showAssignPermission">
      <div class="title-hdr bg-dark">
          {{title}}
      </div>

      <!-- <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" style="width:100%"></div>
      </div> -->

      <div class="card">
          <div class="card-body">
            <data-viewer :source="source" :thead="thead">
              <template slot-scope="props">
                  <tr>
                      <td>{{props.item.role_name}}</td>
                      <td>{{props.item.description}}</td>
                      <td>
                        <button v-if="hasPermission('Edit Role')" class="btn btn-primary btn-sm" data-bs-toggle="tooltip" title="Edit Role" @click="editRole(props.item)">
                          <i class="fas fa-pen fa-sm"></i>
                        </button>
                        <button v-if="hasPermission('Assign Permission')" class="btn btn-secondary btn-sm" data-bs-toggle="tooltip" title="Assign Permission" @click="assignPermission(props.item)">
                          <i class="fas fa-key fa-sm"></i> <!-- key icon for permissions -->
                        </button>
                      </td>
                  </tr>
              </template>
            </data-viewer>
          </div>
      </div>
    </div>

  </div>

</template>

<script>
  import axios from 'axios'
  import { baseUrl } from '../../../.env.js'
  import { bus } from '../../../main.js'

  import DataViewer from './../common/DataViewer.vue'
  import AddEditRole from './AddEditRole.vue'
  import AssignPermission from './AssignPermission.vue'  // import here


  export default {
    name: 'RoleData',
    props: {
      hasPermission: {
        type: Function,
        required: true
      }
    },
    components: {
        DataViewer,
        AddEditRole,
        AssignPermission
    },
    data() {
      return {
        certs: {},
        baseUrl : baseUrl,
        title: 'Roles',
        source: '/user/roles',
        showAddRole: false,
        showAssignPermission: false,  // new state
        roleForPermission: null,      // selected role for permission assignment
        rolePermissions: [],
        editingRole: null,
      }
    },
    mounted() {
      var vm = this;
      this.$store.commit('selectedTab', 'roles');
      this.fetchRoles()

      // Initialize Bootstrap tooltips
      var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        new bootstrap.Tooltip(tooltipTriggerEl)
      })
    },
    methods: {
      addRole() {
        this.editingRole = null
        this.showAddRole = true
      },
      editRole(role) {
        this.editingRole = Object.assign({}, role)  // clone to avoid direct mutation
        this.showAddRole = true
      },
      cancelEdit() {
        this.editingRole = null
        this.showAddRole = false
      },
      onRoleAdded() {
        this.showAddRole = false
        this.fetchRoles()  // refresh roles list after adding
      },
      onRoleUpdated() {
        this.showAddRole = false
        this.editingRole = null
        this.fetchRoles()  // refresh roles list after updating
      },
      fetchRoles() {
        // Fetch roles from API and update this.roles
        // Example:
        // this.$axios.get('/api/v1/user/sys/roles').then(res => {
        //   this.roles = res.data.model.data
        // })
      },
      // New method to open assign permission UI
      assignPermission(role) {
        const url = `/user/roles/${role.role_id}/permissions`
        console.log('Get permission by Role id', url)
        axios.get(url)
          .then((response) => {
            if (response.data) {
              this.rolePermissions = response.data.permissions;
            } else {
              this.rolePermissions = [];
            }
          })
          .catch((error) => {
            this.rolePermissions = [];
          })

        this.roleForPermission = Object.assign({}, role)
        this.showAssignPermission = true
      },
      // Handle cancel from AssignPermission component
      cancelAssignPermission() {
        this.roleForPermission = null
        this.showAssignPermission = false
      },
      saveAssignedPermissions({ roleId, permissions }) {
        if (!roleId) {
          console.error('roleId is undefined!');
          return;
        }
        const url = `/user/roles/${roleId}/permissions`
        var vm = this
        axios.post(url, { permissions })
          .then(response => {
            // Extract success message from response if available
            const message = (response.data && response.data.message) || 'Role permissions saved successfully!'

            Swal.fire({
              type: 'success',
              title: 'Success',
              text: message
            }).then(() => {
              this.showAssignPermission = false
              this.roleForPermission = null
              // this.fetchRoles()
            })
          })
          .catch(err => {
            // Extract error message safely
            let message = 'Failed to save permissions'
            if (err && err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                message = err.response.data
              } else if (err.response.data.error) {
                message = err.response.data.error
              } else if (err.response.data.message) {
                message = err.response.data.message
              }
            }

            Swal.fire({
              type: 'error',
              title: 'Error',
              text: message
            })
            console.error(err)
          })
      },
    },
    computed: {
        thead: function () {
            return [
                {title: 'Role Name', key: 'role_name', sort: true},
                {title: 'Description', key: 'description', sort: true}
            ]
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/users/RoleData.vue